/* eslint-disable @typescript-eslint/no-explicit-any */
import { Reducer, Action, UnknownAction } from '@reduxjs/toolkit'

export const reducerTypeWrapper =
  <S = any, A extends Action = UnknownAction>(
    type: string,
    reducer: Reducer<S, A>
  ): Reducer<S, A> =>
  (state, action: A) => {
    const actionTypeToken = `${type}-`
    if (action && action.type.match(actionTypeToken) !== null) {
      return reducer(state, {
        ...action,
        type: action.type.replace(actionTypeToken, ''),
      })
    }
    return state ?? reducer(undefined, { type: '' } as A)
  }

export const actionTypeWrapper = <T = string>(type: T, action: any) => ({
  ...action,
  type: `${type}-${action.type}`,
})

export const actionTypeWrapperCurried =
  <T extends string>(type: T) =>
  <Params = unknown, ActionReturn extends Action<string> = Action<string>>(
    actionFn: (params: Params) => ActionReturn
  ) =>
  (params: Params) =>
    actionTypeWrapper(type, actionFn(params))
